import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import CasinoIcon from '@mui/icons-material/Casino';
import { auth } from '../../utils';
import { ELocalStorageKeys } from '../../types';
import { useAppDispatch } from '../../hooks';
import { setToken } from '../../store/auth';
import { ModalNew } from '../../components/atoms/Modal/Modal';
import AuthQrCodeReader from '../../components/organisms/AuthQrCodeReader';
import { colors } from '../../styles/colors';
export const Login = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [value, setValue] = useState('');
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [showQrScanner, setShowQrScanner] = useState(false);
    const handleChange = (event) => {
        const numberValue = event.target.value;
        setError(false);
        if (/^\d*$/.test(numberValue)) {
            setValue(numberValue);
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        auth(value)
            .then((res) => {
            setIsLoading(true);
            if (res.accessToken) {
                localStorage.setItem(ELocalStorageKeys.TOKEN, res.accessToken);
                dispatch(setToken(res.accessToken));
                navigate(res.redirectUrl || '/');
            }
            else {
                setError(true);
                setErrorText('Неправильный код');
            }
            setIsLoading(false);
        })
            .catch((err) => {
            console.log(err);
            setIsLoading(false);
            setError(true);
            setErrorText('Ошибка. Попробуйте еще раз');
        })
            .finally(() => {
            setIsLoading(false);
        });
    };
    const handleAuthCodeFound = (code) => {
        setValue(code);
        setShowQrScanner(false);
        auth(code)
            .then((res) => {
            setIsLoading(true);
            if (res.accessToken) {
                localStorage.setItem(ELocalStorageKeys.TOKEN, res.accessToken);
                dispatch(setToken(res.accessToken));
                navigate(res.redirectUrl || '/');
            }
            else {
                setError(true);
                setErrorText('Неправильный код');
            }
            setIsLoading(false);
        })
            .catch((err) => {
            console.log(err);
            setIsLoading(false);
            setError(true);
            setErrorText('Ошибка. Попробуйте еще раз');
        })
            .finally(() => {
            setIsLoading(false);
        });
    };
    return (_jsxs(Box, Object.assign({ sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: colors.background,
            padding: '24px',
        } }, { children: [_jsxs(Box, Object.assign({ sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    maxWidth: '400px',
                    padding: '40px 32px',
                    backgroundColor: colors.surface,
                    borderRadius: '20px',
                    border: `1px solid ${colors.cardBorder}`,
                } }, { children: [_jsx(Box, Object.assign({ sx: {
                            width: '100px',
                            height: '100px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: colors.primary,
                            borderRadius: '20px',
                            marginBottom: '24px',
                        } }, { children: _jsx(CasinoIcon, { sx: { fontSize: 56, color: colors.textPrimary } }) })), _jsx(Typography, Object.assign({ variant: "h3", sx: {
                            marginBottom: '8px',
                            textAlign: 'center',
                        } }, { children: "KULT MAFIA" })), _jsx(Typography, Object.assign({ variant: "subtitle1", sx: {
                            marginBottom: '40px',
                            textAlign: 'center',
                        } }, { children: "\u041F\u0430\u043D\u0435\u043B\u044C \u0432\u0435\u0434\u0443\u0449\u0435\u0433\u043E" })), _jsxs(Box, Object.assign({ component: "form", onSubmit: handleSubmit, sx: {
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                        } }, { children: [_jsx(TextField, { fullWidth: true, placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0434\u043E\u0441\u0442\u0443\u043F\u0430", value: value, onChange: handleChange, error: error, helperText: error ? errorText : '', inputProps: {
                                    style: {
                                        textAlign: 'center',
                                        fontSize: '24px',
                                        fontWeight: 600,
                                        letterSpacing: '4px',
                                    },
                                }, sx: {
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: colors.surfaceVariant,
                                    },
                                } }), _jsx(Button, Object.assign({ type: "submit", variant: "contained", fullWidth: true, disabled: isLoading || !value, sx: {
                                    padding: '14px 24px',
                                    fontSize: '16px',
                                } }, { children: isLoading ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : ('Войти') })), _jsxs(Box, Object.assign({ sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    margin: '8px 0',
                                } }, { children: [_jsx(Box, { sx: { flex: 1, height: '1px', backgroundColor: colors.cardBorder } }), _jsx(Typography, Object.assign({ variant: "body2", sx: { color: colors.textHint } }, { children: "\u0438\u043B\u0438" })), _jsx(Box, { sx: { flex: 1, height: '1px', backgroundColor: colors.cardBorder } })] })), _jsx(Button, Object.assign({ variant: "outlined", fullWidth: true, startIcon: _jsx(QrCodeScannerIcon, {}), onClick: () => setShowQrScanner(true), sx: {
                                    padding: '14px 24px',
                                    fontSize: '16px',
                                } }, { children: "\u0412\u043E\u0439\u0442\u0438 \u043F\u043E QR-\u043A\u043E\u0434\u0443" }))] }))] })), showQrScanner && (_jsx(ModalNew, Object.assign({ onClose: () => setShowQrScanner(false), close: true }, { children: _jsx(AuthQrCodeReader, { onAuthCodeFound: handleAuthCodeFound, onClose: () => setShowQrScanner(false) }) })))] })));
};
